/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadCertificateUserDto
 */
export interface UploadCertificateUserDto {
    /**
     * Base64-encoded .p12 / .pfx file contents
     * @type {string}
     * @memberof UploadCertificateUserDto
     */
    p12Base64: string;
    /**
     * Password for the p12 certificate
     * @type {string}
     * @memberof UploadCertificateUserDto
     */
    password: string;
    /**
     * PWZ number of the physician
     * @type {string}
     * @memberof UploadCertificateUserDto
     */
    pwz?: string;
    /**
     * Identifier of the occupational medicine doctor
     * @type {string}
     * @memberof UploadCertificateUserDto
     */
    occupationalMedicineDoctorIdentifier?: string;
}

/**
 * Check if a given object implements the UploadCertificateUserDto interface.
 */
export function instanceOfUploadCertificateUserDto(value: object): value is UploadCertificateUserDto {
    if (!('p12Base64' in value) || value['p12Base64'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function UploadCertificateUserDtoFromJSON(json: any): UploadCertificateUserDto {
    return UploadCertificateUserDtoFromJSONTyped(json, false);
}

export function UploadCertificateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadCertificateUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'p12Base64': json['p12Base64'],
        'password': json['password'],
        'pwz': json['pwz'] == null ? undefined : json['pwz'],
        'occupationalMedicineDoctorIdentifier': json['occupationalMedicineDoctorIdentifier'] == null ? undefined : json['occupationalMedicineDoctorIdentifier'],
    };
}

export function UploadCertificateUserDtoToJSON(value?: UploadCertificateUserDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'p12Base64': value['p12Base64'],
        'password': value['password'],
        'pwz': value['pwz'],
        'occupationalMedicineDoctorIdentifier': value['occupationalMedicineDoctorIdentifier'],
    };
}

